<template>
  <nav class="breadcrumbs">
    <div class="breadcrumb-item home" @click="$emit('navigate', 'Introduction')">
      <span class="icon">🏠</span>
    </div>
    
    <span class="separator">›</span>
    
    <div class="breadcrumb-item current">
      {{ currentSectionName }}
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    currentSectionName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 2rem;
  font-family: sans-serif;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

/* Estilo del Home (la casita) */
.home {
  cursor: pointer;
  color: var(--text-color);
  padding: 6px 8px;
}

.home:hover {
  background: var(--sidebar-bg);
  transform: translateY(-1px);
}

.separator {
  color: #94a3b8;
  font-size: 1.2rem;
  font-weight: 300;
}

/* Estilo de la cápsula (como en tu imagen) */
.current {
  background: var(--sidebar-bg);
  color: var(--primary-color);
  font-weight: 600;
  border: 1px solid var(--border-color);
}

/* Ajuste para modo oscuro */
.dark .current {
  background: rgba(59, 130, 246, 0.1); /* Un fondo azul tenue */
  border-color: rgba(59, 130, 246, 0.3);
}
</style>